import { IAvailabilityIngestion } from '@/bundles/AvailabilityIngestion/types';
import { Nullable } from '@/utils/types';

import { IAvailabilityIngestionStore } from './index';

export default {
  recordById: (state: IAvailabilityIngestionStore) => (id: string): Nullable<IAvailabilityIngestion> => {
    return state.records[id] ?? null;
  },

  listForFilterKey: (state: IAvailabilityIngestionStore) => (key: string): IAvailabilityIngestion[] => {
    const listing = state.listings[key];
    if (!listing) return [];
    return listing.ids
      .map((id) => state.records[id])
      .filter((record): record is IAvailabilityIngestion => Boolean(record));
  },

  listingMeta: (state: IAvailabilityIngestionStore) => (key: string) => {
    return state.listings[key] ?? { ids: [], loading: false, error: null };
  },
};
